import { createRoot } from 'react-dom/client'
import './css/ta-legacy.css'
import App from './App'

// Polyfill Object.hasOwn for Chrome < 93
if (!('hasOwn' in Object)) {
  Object.defineProperty(Object, 'hasOwn', {
    value(obj: object, prop: PropertyKey) {
      return Object.prototype.hasOwnProperty.call(obj, prop)
    },
    writable: true,
    configurable: true,
  })
}

// Polyfill Array.prototype.at for Chrome < 92
if (!(Array.prototype as any).at) {
  Object.defineProperty(Array.prototype as any, 'at', {
    value(index: number) {
      const n = Math.trunc(index) || 0
      const i = n >= 0 ? n : this.length + n
      return i >= 0 && i < this.length ? this[i] : undefined
    },
    writable: true,
    configurable: true,
  })
}

// Polyfill structuredClone for Chrome < 98 / Firefox < 94 / Safari < 15.4.
// Everything we clone in this codebase is JSON-safe (style groups, tweak
// lists, TextStructure trees) so a JSON round-trip is a faithful fallback.
// It does NOT support Date / Map / Set / RegExp / typed arrays - if a
// caller starts cloning those, swap this for a real polyfill package.
if (typeof (globalThis as any).structuredClone !== 'function') {
  (globalThis as any).structuredClone = function structuredClonePolyfill<T>(value: T): T {
    return value === undefined ? value : JSON.parse(JSON.stringify(value))
  }
}

createRoot(document.getElementById('root')!).render(
  <App />
)
